import { useState } from "react";
import { Dialog } from "@components/Dialog";
import styles from "./index.module.css";

export type HorizontalBarChartProps = {
  chartTitle: string;
  chartLabel?: string;
  showsInProgress: boolean;
  chartData: { colorCode: string; label: string; value: number }[];
};

export const PERCENTAGE_THRESHOLD = 10;

const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
  chartTitle,
  chartLabel,
  showsInProgress,
  chartData,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const modalHandlers = {
    open: () => {
      setIsOpened(true);
    },
    close: () => setIsOpened(false),
  };

  const barWidth = (visitorsRate: number) => {
    const maxWidth = 100;
    const minWidth = 0;
    const width = Math.max(minWidth, Math.min(maxWidth, visitorsRate));
    return `${width}%`;
  };

  return (
    <>
      <div
        className={styles.horizontalBarChartWrapper}
        onClick={() => {
          chartData && chartData.length > 0 && modalHandlers.open();
        }}
      >
        <div className={styles.horizontalBarChartHeader}>
          <div className={styles.horizontalBarChartTitle}>{chartTitle}</div>
          {chartLabel && (
            <div className={styles.horizontalBarChartLabel}>{chartLabel}</div>
          )}
        </div>
        {showsInProgress ? (
          <p className={styles.inProgress}>集計中...</p>
        ) : (
          <>
            <ol className={styles.horizontalBarChart}>
              {chartData.map((item, index) => (
                <li
                  key={index}
                  style={{
                    width: barWidth(item.value),
                    backgroundColor: item.colorCode,
                  }}
                >
                  {/*
                    割合が小さいと表示しきれない場合があるので10%未満の場合は非表示にする
                    10%未満でも他の要素の割合によっては表示できる場合もあるがCSSでの調整が難しいのでこの対応とする
                    */}
                  {item.value >= PERCENTAGE_THRESHOLD ? `${item.value}%` : ""}
                </li>
              ))}
            </ol>

            <div className={styles.overFlowEllipsis}>
              <ul className={styles.horizontalBarChartLegend}>
                {chartData.map((item, index) => (
                  <li key={index}>
                    <i
                      className={styles.labelColor}
                      style={{
                        backgroundColor: item.colorCode,
                      }}
                    ></i>
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
      <Dialog
        open={isOpened}
        title="比率内訳"
        onClose={modalHandlers.close}
        markdown={false}
      >
        <ul className={styles.horizontalBarChartDialogLabel}>
          {chartData.map((item, index) => (
            <li key={index}>
              <div className={styles.labelWrapper}>
                <i
                  className={styles.labelColor}
                  style={{
                    backgroundColor: item.colorCode,
                  }}
                ></i>
                {item.label}
              </div>
              <span className={styles.value}>{item.value}%</span>
            </li>
          ))}
        </ul>
      </Dialog>
    </>
  );
};

export default HorizontalBarChart;
